import { formatEventStatusTabLabel } from "../../../../../utils/Helpers";
import { EVENT_VIEW_TABS } from "../../../../../utils/eventViewTabs";

/**
 * Event-scoped report detail breadcrumbs:
 * Events / {status} / {eventName} / Report / {reportTitle}
 */
export const buildEventScopedReportBreadcrumbs = ({
  eventsListPath,
  eventViewPath,
  eventStatus,
  eventName,
  reportIdLabel: reportTitle,
  reportCrumbLabel,
  eventsMessages,
}) => {
  const listEvents = eventsMessages?.listEvents || {};
  const reportsTabPath = `${eventViewPath}?tab=${EVENT_VIEW_TABS.reports}`;
  const statusLabel = formatEventStatusTabLabel(
    eventStatus,
    listEvents.eventTabs,
  );

  const breadcrumbs = [
    {
      path: eventsListPath,
      label: listEvents.listEventsBreadcrumb,
    },
  ];

  if (statusLabel) {
    breadcrumbs.push({
      path: `${eventsListPath}?tab=${eventStatus}`,
      label: statusLabel,
    });
  }

  breadcrumbs.push(
    {
      path: eventViewPath,
      label: eventName || "",
    },
    {
      path: reportsTabPath,
      label: reportCrumbLabel,
      state: { initialTab: EVENT_VIEW_TABS.reports },
    },
    {
      path: "",
      label: reportTitle,
    },
  );

  return breadcrumbs;
};
